import { invitationShowOptions } from '$api-client/@tanstack/react-query.gen'
import { InvitationRoutePath } from '$features/invitations/routes/public'
import { Router } from '$utils/router'
import { useQuery } from '@tanstack/react-query'
import { ReactNode } from 'react'
import { Navigate, useParams } from 'react-router'

export type RequiresVerificationProps = {
  children: ReactNode,
}

export function RequiresVerification({ children }: RequiresVerificationProps) {
  const { token } = useParams()

  const { data: invitation } = useQuery({
    ...invitationShowOptions({
      path: {
        token: token!,
      },
    }),
  })

  return (
    <div>
      { invitation?.data.verified_at ? children : <Navigate to={Router.getRoute(InvitationRoutePath.InvitationsVerify, { token: token! })} /> }
    </div>
  )
}
